import {SalesDashboardRepository} from '../repository/SalesDashboardRepository';
import type {BaseResponse} from '../../../Data/types/BaseResponse';

export class ReviewBankTransferUseCase {
  constructor (private readonly repo: SalesDashboardRepository) {}

  async execute (payload: {invoice_id: number; action: 'approved'|'rejected'; notes?: string}): Promise<BaseResponse<unknown>> {
    return this.repo.reviewBankTransfer(payload);
  }
}


